// Only application-owned destinations; never accept an arbitrary login redirect.
export function networkDestination({ authenticated, role, slug }) {
  if (!authenticated || !['professional', 'company', 'recruiter'].includes(role) || !slug) {
    return { path: '/login', query: { next: '/network' }, replace: true };
  }
  return { path: `/dashboard/${role}/${encodeURIComponent(slug)}/feed`, replace: true };
}
